import { createFileRoute, type SearchSchemaInput } from "@tanstack/react-router";
import { ProjectsPageContainer } from "@charphq/ui/components/layout/pages/ProjectsPageContainer";

export const Route = createFileRoute("/projects")({
  component: ProjectsPageComponent,
  // SearchSchemaInput marker + all-optional output: navigations to this route
  // (and, on desktop, its nested detail route) never require a `search` prop;
  // the URL sync hook applies defaults (page 1, size 50).
  validateSearch: (search: Record<string, unknown> & SearchSchemaInput) => ({
    page: search.page ? Number(search.page) : undefined,
    pageSize: search.pageSize ? Number(search.pageSize) : undefined,
    sortBy: (search.sortBy as string) || undefined,
    sortDirection: (search.sortDirection as "asc" | "desc") || undefined,
    globalFilter: (search.globalFilter as string) || undefined,
    columnFilters: (search.columnFilters as Record<string, unknown>) || undefined,
  }),
});

function ProjectsPageComponent() {
  const search = Route.useSearch();

  return (
    <ProjectsPageContainer
      searchParams={search}
      breadcrumbs={[{ label: "Home", href: "/" }, { label: "Projects" }]}
    />
  );
}
